import React from "react";
import { FaSpinner } from "react-icons/fa";

const Spinner = () => {
  return (
    <div className="absolute top-0 start-0 w-full h-full flex flex-row items-center justify-center z-100 bg-black opacity-50">
      <FaSpinner className="text-purple-500 animate-spin" style={{ fontSize: '4rem' }} />
    </div>
  )
}

export default Spinner;
